import React from 'react';
import styled from 'styled-components';

const LabelWrapper = styled.label`
  font-size: 0.8571428571428571em;
  font-style: inherit;
  line-height: 1.3333333333333333;
  color: #6b778c;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 4px;
  margin-top: 16px;
  span {
    color: red;
  }
`;
const IndenpendentLabel = ({
  label,
  htmlFor,
  isRequired = false,
}: {
  label?: string | JSX.Element;
  htmlFor?: string;
  isRequired?: boolean;
}) => {
  return label ? (
    <LabelWrapper className={'label-wrapper'} htmlFor={htmlFor || 'label'}>
      {label}
      {isRequired && <span>*</span>}
    </LabelWrapper>
  ) : null;
};

export default IndenpendentLabel;
